import { useIntl } from 'react-intl';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { useWatch } from 'react-hook-form';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { Box } from '@packages/shared/src/components/Box/Box';
import { Button } from '@packages/shared/src/components/Button/Button';
import { Link } from '@packages/shared/src/components/Link/Link';
import { basicContainer } from './styles';
import { generalFormMessages } from './messages';
import { unsubscribeMessages } from './NewsletterUnsubscribeForm/helpers/messages';

export type FormFooterAreaProps = {
  /** Indicates that the form is valid and the button should be enabled */
  isValid: boolean;
  submitButton: {
    /** Button text when the button is enabled */
    enabled: string;
    /** Button text when the button is disabled */
    disabled: string;
  };
};

/**
 * Renders the bottom area of the form with a button and a link back to storefront
 */
export const FormFooterArea = ({ isValid, submitButton }: FormFooterAreaProps) => {
  const { formatMessage } = useIntl();
  const { isMobile } = useDeviceType();
  const frequency = useWatch({ name: 'frequency' });
  const {
    forms: {
      newsletterUnsubscribe: { useDedicatedSubmitButtonTitleFor },
    },
  } = useConfig();
  const enabledButtonLabel = useDedicatedSubmitButtonTitleFor?.includes(frequency)
    ? formatMessage(unsubscribeMessages.submitButtonTitle)
    : submitButton.enabled;

  return (
    <Box sx={{ ...basicContainer, textAlign: 'center', paddingTop: 2 }}>
      <Button
        disabled={!isValid}
        size="large"
        fullWidth={isMobile}
        color="primary"
        type={isValid ? 'submit' : 'button'}
      >
        {isValid ? enabledButtonLabel : submitButton.disabled}
      </Button>

      <Box sx={{ ...basicContainer, color: 'text.darkTransparent' }}>
        <Link href="/" color="inherit" sx={{ paddingTop: 2.5, display: 'block' }}>
          {formatMessage(generalFormMessages.backToStorefront)}
        </Link>
        <Box sx={{ paddingTop: 4, typography: 'body3' }}>
          {formatMessage(generalFormMessages.mandatory)}
        </Box>
      </Box>
    </Box>
  );
};
